import { render, staticRenderFns } from "./MultiChoiceQuestionForm.vue?vue&type=template&id=3fc30da9"
import script from "./MultiChoiceQuestionForm.vue?vue&type=script&lang=ts"
export * from "./MultiChoiceQuestionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports